export default __webpack_public_path__ + "static/media/picstack.6e77b4bd.png";